var angular = require('angular');
var moment = require('moment');
var _module = require('./index');
var REPORT_TEMPLATES_HOST = "https://s3.us-west-2.amazonaws.com/listreports-templates";

_module
    .factory('$utils', ['$q', '$http', '$events', function($q, $http, $events) {
        return {
            isImage: function(url) {
                var defer = $q.defer();
                var image = new Image();

                image.onerror = function() {
                    defer.reject();
                };

                image.onload = function() {
                    defer.resolve();
                };

                image.src = url;

                return defer.promise;
            },

            hasTouchSupprt: function() {
                return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
            },

            sendEmail: function (to, subject, body) {
                var API_URL  = "https://www.listreports.com";
                var defer    = $q.defer();
                var endpoint = API_URL + '/v1/send-email/generic';
                var payload  = {
                    to      : to,
                    subject : subject,
                    body    : body
                };

                $http
                    .post(endpoint, payload)
                    .success(function (response) {
                        console.log('Email Sent: ', response);
                        defer.resolve();
                    })
                    .error(function (err){
                        console.log('Email Error: ', err);
                        defer.reject(err);
                    });

                return defer.promise;
            },

            injectCss: function (path) {
                if(path){
                    try{
                        const link = document.createElement( 'link' );
                        link.href = path;
                        link.type = 'text/css';
                        link.rel = 'stylesheet';
                        link.media = 'screen,print';

                        document.getElementsByTagName( 'head' )[0].appendChild( link );
                    }catch(e){
                        console.log('Error trying to inject CSS: ', e);
                    }
                }
            },

            loadTheme: function (report, target, templateCategory) {
                const _this = this;
                const themesParentPrefix = (templateCategory) ? templateCategory + '_' : '';
                const _applyTheme = function (theme) {
                    // no need to inject theme css if theme is default
                    if(theme === 'default') return;
                    angular.element('body').addClass(theme);
                    const cssPath = REPORT_TEMPLATES_HOST + '/assets/' + themesParentPrefix + 'themes/' + theme + '/' + target + '.css';
                    _this.injectCss(cssPath);
                };

                if(report && report.meta && report.meta.theme){
                    const theme = report.meta.theme;
                    _applyTheme(theme);
                } else if(report && report.theme && report.theme.length) {
                    _applyTheme(report.theme);
                }
            },

            showWebShare: function showWebShare(url, title, setOpenFallback) {
                if(navigator.share) {
                    navigator.share({
                        title: title,
                        url: url,
                    })
                    .finally(function () {
                        $events.track('spw_share_button_click');
                    });
                } else if(setOpenFallback){
                    setOpenFallback(true);
                }
            },

            isInIframe: function isInIframe() {
                try {
                    return window.self !== window.top;
                } catch (e) {
                    return true;
                }
            },

            parseReportOpenHouses: function parseOpenHousesData(openHouseStr, id, description) {
                function _formatTime(time) {
                    if(!~time.indexOf(':')) time = time + ':00';
                    return time;
                }

                var openHouseTests = [
                    {
                        regex: /\w+\s(\d{1,2})\/(\d{1,2})(?:\s&\s\w+\s(\d{1,2})\/(\d{1,2})){0,}\s.\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)\s\-\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)/i,
                        format: function(matches) {
                            return [
                                [
                                    parseInt(matches[0]), // Month
                                    parseInt(matches[1]), // Day
                                    _formatTime(matches[4]) + ' ' + matches[5], // Start Time
                                    _formatTime(matches[6]) + ' ' + matches[7], // End Time
                                ],
                                [
                                    parseInt(matches[2]), // Month
                                    parseInt(matches[3]), // Day
                                    _formatTime(matches[4]) + ' ' + matches[5], // Start Time
                                    _formatTime(matches[6]) + ' ' + matches[7], // End Time
                                ],
                            ];
                        },
                    },
                    {
                        regex: /\w+\s(\d{1,2})\/(\d{1,2}){0,}\s.\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)\s\-\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)\s&\s\w+\s(\d{1,2})\/(\d{1,2}){0,}\s.\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)\s\-\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)/i,
                        format: function(matches) {
                            return [
                                [
                                    parseInt(matches[0]), // Month
                                    parseInt(matches[1]), // Day
                                    _formatTime(matches[2]) + ' ' + matches[3], // Start Time
                                    _formatTime(matches[4]) + ' ' + matches[5], // End Time
                                ],
                                [
                                    parseInt(matches[6]), // Month
                                    parseInt(matches[7]), // Day
                                    _formatTime(matches[8]) + ' ' + matches[9], // Start Time
                                    _formatTime(matches[10]) + ' ' + matches[11], // End Time
                                ],
                            ];
                        },
                    },
                    {
                        regex: /\w+\s(\d{1,2})\/(\d{1,2})\s.\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)\s\-\s(\d+(?:\:\d\d){0,})(?:\s){0,}(am|pm)/i,
                        format: function(matches) {
                            return [
                                [
                                    parseInt(matches[0]), // Month
                                    parseInt(matches[1]), // Day
                                    _formatTime(matches[2]) + ' ' + matches[3], // Start Time
                                    _formatTime(matches[4]) + ' ' + matches[5], // End Time
                                ],
                            ];
                        },
                    },
                ];

                var openHouseData = openHouseTests.reduce(function(result, test) {
                    if(!result.length) {
                        var matches = (openHouseStr.match(test.regex) || []).slice(1);
                        var allMatchesExist = matches.reduce(function(result, match) {
                            if(!match) result = false;
                            return result;
                        }, true);
                        if(matches.length && allMatchesExist) result = test.format(matches);
                    }

                    return result;
                }, []);

                const currentYear = moment().format('YYYY').toString();
                const currentDate = moment().format('YYYY-MM-DD').toString();

                const parsedOpenHouseData = openHouseData.map(function(openHouse) {
                    const date = moment([currentYear, openHouse[0], openHouse[1]].join('-'), 'YYYY-M-D').format('YYYY-MM-DD');
                    const date_iso = moment(date).toISOString();
                    const start_time =  openHouse[2];
                    const start_time_iso = moment([date, start_time].join(' '), 'YYYY-MM-DD H:mm a').toISOString();
                    const end_time = openHouse[3];
                    const end_time_iso = moment([date, end_time].join(' '), 'YYYY-MM-DD H:mm a').toISOString();
                    return ({
                        description: description,
                        date: date,
                        date_iso: date_iso,
                        start_time: start_time,
                        start_time_iso: start_time_iso,
                        end_time: end_time,
                        end_time_iso: end_time_iso
                    })
                });

                const removePastDates = parsedOpenHouseData.filter(function(openHouse) {
                    return openHouse.date  >= currentDate;
                });

                return removePastDates;
            }
        };
    }])
;